(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-bundle"] && !Shopify.designMode) return;
  try {
    class BundleQuantitySelectorElement extends HTMLElement {
    connectedCallback() {
      /** @type {NodeListOf<HTMLButtonElement>} */
      this.optionButtons = this.querySelectorAll('.bundle-selector__option');

      // Sync the theme's quantity input from the pre-selected card on page load
      const preSelected = this.querySelector('.bundle-selector__option--selected');
      if (preSelected) {
        this._syncQuantity(preSelected.dataset.quantity || '1');
      }

      this.optionButtons.forEach((btn) => {
        btn.addEventListener('click', this._onOptionClick.bind(this));
      });
      this._initSubscriptionSync();
    }

    /** @param {MouseEvent} event */
    _onOptionClick(event) {
      const selected = /** @type {HTMLButtonElement} */ (event.currentTarget);

      // Deselect all
      this.optionButtons.forEach((btn) => {
        btn.classList.remove('bundle-selector__option--selected');
        btn.setAttribute('aria-checked', 'false');
      });

      // Activate clicked card
      selected.classList.add('bundle-selector__option--selected');
      selected.setAttribute('aria-checked', 'true');

      this._syncQuantity(selected.dataset.quantity || '1');
    }

    /**
     * Updates the quantity input(s) inside the theme's buy-buttons product form
     * so the theme's own ATC button submits the correct quantity.
     * @param {string} qty
     */
    _syncQuantity(qty) {
      const sectionId = this.dataset.sectionId;

      // The theme's product form lives inside the Shopify section wrapper.
      // buy-buttons.liquid uses: form id="BuyButtons-ProductForm-{{ section.id }}"
      const sectionEl = document.getElementById('shopify-section-' + sectionId);
      if (!sectionEl) return;

      const form = sectionEl.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      // 1. Update all hidden/visible quantity inputs inside the form.
      // If none exist (quantity block removed), inject a hidden one so the
      // add-to-cart form still receives the selected bundle quantity.
      let quantityInputs = form.querySelectorAll('input[name="quantity"]');
      if (!quantityInputs.length) {
        const hiddenQty = document.createElement('input');
        hiddenQty.type = 'hidden';
        hiddenQty.name = 'quantity';
        hiddenQty.value = qty;
        form.appendChild(hiddenQty);
        quantityInputs = [hiddenQty];
      }
      quantityInputs.forEach((input) => {
        input.value = qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // 2. Also update the visible number input inside quantity-selector-component
      //    so the +/- stepper UI stays in sync
      const qtySelectorInput = form.querySelector(
        'quantity-selector-component input[type="number"], ' +
        'cart-quantity-selector-component input[type="number"]'
      );
      if (qtySelectorInput) {
        qtySelectorInput.value = qty;
        qtySelectorInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtySelectorInput.dispatchEvent(new Event('input',  { bubbles: true }));
      }
    }
      _initSubscriptionSync() {
  const sectionEl = document.getElementById('shopify-section-' + this.dataset.sectionId);
  if (!sectionEl) return;

  this.subscriptionRadios = sectionEl.querySelectorAll(
    '.shopify_subscriptions_app_block input[type="radio"]'
  );

  if (!this.subscriptionRadios.length) return;

  this.subscriptionRadios.forEach((radio) => {
    radio.addEventListener('change', (e) => {
      const type = radio.getAttribute('data-radio-type');

      if (type === 'selling_plan' && radio.checked) {
        this._forceOnePack();
        this._toggleBundle(false); // disable others
      }

      if (type === 'one_time_purchase' && radio.checked) {
        this._toggleBundle(true); // enable all
      }
    });
  });
}

_forceOnePack() {
  let firstOption = null;

  this.optionButtons.forEach((btn) => {
    const qty = btn.dataset.quantity;

    if (qty === "1") {
      firstOption = btn;
    }

    btn.classList.remove('bundle-selector__option--selected');
    btn.setAttribute('aria-checked', 'false');
  });

  if (firstOption) {
    firstOption.classList.add('bundle-selector__option--selected');
    firstOption.setAttribute('aria-checked', 'true');

    this._syncQuantity("1");
  }
}

_toggleBundle(enable) {
  this.optionButtons.forEach((btn) => {
    const qty = btn.dataset.quantity;

    if (qty !== "1") {
      btn.style.pointerEvents = enable ? "auto" : "none";
      btn.style.opacity = enable ? "1" : "0.5";
    }
  });
}
  }

  if (!customElements.get('bundle-quantity-selector')) {
    customElements.define('bundle-quantity-selector', BundleQuantitySelectorElement);
  }
  } catch(e) { console.error(e); }
})();

})();
